import { initialState } from './state'
import { PayloadAction } from '@reduxjs/toolkit'
import { FilterMessageOption, Offer, OffersSliceState } from 'src/core/models'

const reducers = {
  /* Offers List Reducers */
  setOffersListLoading: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.offers.loading = action.payload
  },
  setOffersList: (state: OffersSliceState, action: PayloadAction<Offer[]>) => {
    state.offers.offers = action.payload
    state.offers.filteredOffers = action.payload
  },
  setOffersFilterText: (state: OffersSliceState, action: PayloadAction<string>) => {
    state.offers.filterText = action.payload
  },
  filterOffersByText: (state: OffersSliceState, action: PayloadAction<string>) => {
    const oldOffers = state.offers.offers
    const text = action.payload?.toLocaleLowerCase()
    if (text === undefined || text === null || text?.trim()?.length === 0) {
      state.offers.filteredOffers = oldOffers
    } else {
      const newOffers = oldOffers.filter((offer: Offer) => {
        return offer.project_name.toLowerCase().includes(text)
      })
      state.offers.filteredOffers = newOffers
    }
  },
  // eslint-disable-next-line max-len
  filterOffersByOption: (state: OffersSliceState, action: PayloadAction<{ option: FilterMessageOption, userId: number }>) => {
    const oldOffers = state.offers.offers
    const { option, userId } = action.payload
    if (option === 'ALL') {
      state.offers.filteredOffers = state.offers.offers
      state.offers.filterText = null
    } else if (option === 'SENT') {
      const newOffers = oldOffers.filter((offer: Offer) => offer.receiver !== userId)
      state.offers.filteredOffers = newOffers
    } else if (option === 'INBOX') {
      const newOffers = oldOffers.filter((offer: Offer) => offer.receiver === userId)
      state.offers.filteredOffers = newOffers
    }
  },
  // Decline Offer
  setOffersDeclineLoading: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.declineOffer.loading = action.payload
  },
  setOffersDeclineSuccess: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.declineOffer.success = action.payload
  },
  resetOffersDeclineState: (state: OffersSliceState) => {
    state.declineOffer = initialState.declineOffer
  },
  // Accept Offer
  setOffersAcceptLoading: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.acceptOffer.loading = action.payload
  },
  setOffersAcceptSuccess: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.acceptOffer.success = action.payload
  },
  resetOffersAcceptState: (state: OffersSliceState) => {
    state.acceptOffer = initialState.acceptOffer
  },
  // Others
  updateOfferState: (state: OffersSliceState, action: PayloadAction<{ id: number, newState: string}>) => {
    const { id, newState } = action.payload
    const newOffers = state.offers.offers.map((o: Offer) => {
      if (o.id === id) return { ...o, state: newState }
      return { ...o }
    })
    const filteredOffers = state.offers.filteredOffers.map((o: Offer) => {
      if (o.id === id) return { ...o, state: newState }
      return { ...o }
    })
    state.offers.offers = newOffers
    state.offers.filteredOffers = filteredOffers
  },

  // Send Requests Reducers
  setRequestForProposalLoading: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.sendRequestForProposal.loading = action.payload
  },
  setRequestForProposalSuccess: (state: OffersSliceState, action: PayloadAction<boolean>) => {
    state.sendRequestForProposal.success = action.payload
  },
  resetRequestForProposalState: (state: OffersSliceState) => {
    state.sendRequestForProposal = initialState.sendRequestForProposal
  },
}

export default reducers
